import PropTypes from 'prop-types';
import React from 'react';

/** Left-aligned step title, e.g. "Overpayment <i>dispute</i>". */
const StepHeader = ({ name, cursive }) => (
  <h3 className="resolve__title">
    {name} {cursive && <span className="text-cursive">{cursive}</span>}
  </h3>
);

StepHeader.propTypes = {
  name: PropTypes.string,
  cursive: PropTypes.string
};

export { StepHeader };
